import { NotificationRegistry } from '@neos/core'
import AddressHasChangedNotificationArgs from '@src/dataObjects/AddressHasChangedNotificationArgs'
import EnterpriseHasChangedNotificationArgs from '@src/dataObjects/EnterpriseHasChangedNotificationArgs'
import NeosDataImportBackgroundExecutionStateChangedEventArgs from '@src/dataObjects/NeosDataImportBackgroundExecutionStateChangedEventArgs'
import NeosDataImportTemplateUpdatedEventArgs from '@src/dataObjects/NeosDataImportTemplateUpdatedEventArgs'

/**
 * Represents Notifications.
 */
export default class Notifications extends NotificationRegistry {
  /**
   * Gets or sets AddressHasChangedNotification.
   */
  addressHasChangedNotification = this.create<AddressHasChangedNotificationArgs, void>('AddressHasChangedNotification')

  /**
   * Gets or sets EnterpriseHasChangedNotification.
   */
  enterpriseHasChangedNotification = this.create<EnterpriseHasChangedNotificationArgs, void>('EnterpriseHasChangedNotification')

  /**
   * Gets or sets NeosDataImportBackgroundExecutionStateChanged.
   */
  neosDataImportBackgroundExecutionStateChanged = this.create<NeosDataImportBackgroundExecutionStateChangedEventArgs, void>('NeosDataImportBackgroundExecutionStateChanged')

  /**
   * Gets or sets NeosDataImportTemplateUpdated.
   */
  neosDataImportTemplateUpdated = this.create<NeosDataImportTemplateUpdatedEventArgs, void>('NeosDataImportTemplateUpdated')
}